import React from 'react'

// All glyphs render in `currentColor` so the parent can tint them via the
// active semantic token (muted vs. decisive-green).

export const CheckGlyph = () => (
  <svg
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2.6'
    viewBox='0 0 24 24'
    width='100%'
  >
    <path d='M20 6L9 17l-5-5' />
  </svg>
)

export const XGlyph = () => (
  <svg
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2.6'
    viewBox='0 0 24 24'
    width='100%'
  >
    <path d='M18 6L6 18M6 6l12 12' />
  </svg>
)

export const ChevronRightGlyph = () => (
  <svg
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2.2'
    viewBox='0 0 24 24'
    width='100%'
  >
    <path d='M9 6l6 6-6 6' />
  </svg>
)

export const FlagGlyph = () => (
  <svg fill='currentColor' height='100%' viewBox='0 0 448 512' width='100%'>
    <path d='M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.4 141.4 6.4l34.7-13.9c12.3-4.9 20.4-16.8 20.4-30V66.8c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z' />
  </svg>
)
